import { Badge } from '@/components/ui/badge'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

const DEFAULT_TOOLTIP = 'This feature is in beta and may change or behave unexpectedly.'

interface BetaBadgeProps {
  tooltip?: string
  className?: string
}

/**
 * Small "Beta" pill for flagging in-progress feature surfaces.
 * Hover shows a tooltip explaining the feature may still change.
 *
 * @example
 * <h2>Domain & Inbox <BetaBadge /></h2>
 */
export function BetaBadge({ tooltip = DEFAULT_TOOLTIP, className }: BetaBadgeProps) {
  return (
    <TooltipProvider>
      <Tooltip delayDuration={0}>
        <TooltipTrigger asChild>
          <Badge variant="beta" className={cn('align-middle', className)}>
            Beta
          </Badge>
        </TooltipTrigger>
        <TooltipContent side="top">{tooltip}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
